
class ListUi {
   static init(site, view) {
      $('#profile-view-select').change((e) => {
         changeWidth('profile-view-select')
         // console.log('View Select', site, view, $(e.target).val())
         window.location.href = BaseURL+'/'+site+'/'+$(e.target).val()
      })
      $('#profile-site-select').change((e) => {
         changeWidth('profile-site-select')
         // console.log('Site Select', $(e.target).val())
         window.location.href = BaseURL+$(e.target).val()
      })

      let text = $('#profile-view-select option:selected').text()
      changeWidth('profile-view-select')
      changeWidth('profile-site-select')

      function changeWidth(id){
         $('#'+id).width( $('#' + id + ' option:selected').text().length*20 + 20 + "px")
      }

   }
}

module.exports = ListUi
